import { Typography } from "@mui/material";
import React from "react";
import uploadSuccess from "../../../assets/images/videoUploadSuccess.svg";
import "./videoupload.scss";
import { useNavigate } from "react-router-dom";
import {
  ROM_LEFT_EXTENSION,
  ROM_RIGHT_EXTENSION,
  ROM_TEST_FLIP,
  USER_LIST,
} from "../../../routes/routerPath";
import { searchParams } from "../../../utlis/helpers";
import { pageLocale } from "../../../utlis/locale";

const VideoUploadedSuccess = ({ styleChange }) => {
  const moduleInfo = JSON.parse(sessionStorage.getItem("fromUpload") || "");

  const romPageStatus = sessionStorage.getItem("romStatus");
  const navigate = useNavigate();

  const urlPath = window.location.pathname;
  const { upload_success, alert_info, done } = pageLocale("videoUpload");
  const romPathHandler = () => {
    if (urlPath === "/rom-left-flexion") {
      navigate(ROM_LEFT_EXTENSION + `${searchParams}`);
    }
    if (urlPath === "/rom-left-extension") {
      navigate(ROM_TEST_FLIP + `${searchParams}`);
    }
    if (urlPath === "/rom-right-flexion") {
      navigate(ROM_RIGHT_EXTENSION + `${searchParams}`);
    }
    if (urlPath === "/rom-right-extension") {
      navigate(USER_LIST + `${searchParams}`);
      sessionStorage.setItem("romStatus", "");
      sessionStorage.setItem("romReportId", "");
    }
  };

  const doneHandler = () => {
    if (romPageStatus === "enter" || romPageStatus === "success") {
      sessionStorage.setItem("romStatus", "success");
      romPathHandler();
      // navigate(0);
    } else {
      navigate(USER_LIST + `${searchParams}`);
    }
  };

  return (
    <div className="video-upload-status-wrappper">
      {!styleChange && (
        <Typography className="title">{moduleInfo?.moduleName}</Typography>
      )}
      <div className={`video-upload-content-wrap`}>
        <img src={uploadSuccess} alt="success" className="img" />
        <Typography className="success-msg">{upload_success}</Typography>
        <Typography className="report-msg">{alert_info}</Typography>
        <button onClick={() => doneHandler()} className="done-btn">
          {done}
        </button>
      </div>
    </div>
  );
};

export default VideoUploadedSuccess;
